export const isValidArray = (v?: unknown) => Array.isArray(v) && v.length > 0;
